function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "linear-gradient-dakel",
  x1: 241.49,
  y1: 709.16,
  x2: 241.49,
  y2: 383.39,
  gradientTransform: "translate(-46.47 -364.39)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#f92b7f"
}), React.createElement("stop", {
  offset: 0.06,
  stopColor: "#f93377"
}), React.createElement("stop", {
  offset: 0.33,
  stopColor: "#f75753"
}), React.createElement("stop", {
  offset: 0.59,
  stopColor: "#f67039"
}), React.createElement("stop", {
  offset: 0.82,
  stopColor: "#f58029"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#f58524"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#ed693c"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#ed6d3c"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#ef773d"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#f1893f"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#f28f3f"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#fdc60b"
})), React.createElement("linearGradient", {
  id: "linear-gradient-dakel-2",
  x1: 738.61,
  y1: 1114.21,
  x2: 738.61,
  y2: 433.12,
  xlinkHref: "#linear-gradient"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("title", null, "Dakel_only_gradient");

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  className: "dakel-icon-1",
  fill: "url('#linear-gradient-dakel')",
  d: "M198.26,344.77A133.23,133.23,0,0,1,241,323.69L214.66,19c-48.47,58.56-65.59,115.68-65.59,167.93,0,61.44,23.6,116.4,49,157.66Z",
  transform: "translate(-86 -19)"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  className: "dakel-icon-2",
  fill: "url('#linear-gradient-dakel-2')",
  d: "M1276.47,539.55a74.39,74.39,0,0,0-22-11.89,85.3,85.3,0,0,0-36.94-2.34,75.77,75.77,0,0,0-27.39,10.45L1112,474.14a535.32,535.32,0,0,0-16-76.94l-.36-2.34.36-2.7,57.3-179.46a8.53,8.53,0,0,1,7.21-5.95c61.26-7.93,92.07-36.4,109-66.31,15.86-28.11,18.56-57.84,18.74-71.71H1251.6V99c0,4.68-17.3,4.68-17.3,0h0V68.91L997.91,70,984,86.57l-15.68,19.28L871.24,227.29a25.77,25.77,0,0,0-3.6,13.15,26.62,26.62,0,0,0,21.26,26.13l120.9,25.77a29.33,29.33,0,0,0,5.59.54,26.72,26.72,0,0,0,26.67-26.67V112.15a8.65,8.65,0,1,1,17.3,0V266a43.91,43.91,0,0,1-44,44h-.18a49.26,49.26,0,0,1-9-.9L893.4,284.95l-14.77,44.69a8.49,8.49,0,0,1-8.11,5.95h-593A116.27,116.27,0,0,0,161.32,451.8V581.89a8.88,8.88,0,0,1-4.68,7.75h-.18l-.54.18-2.16,1.26c-1.8,1.08-4.68,2.7-7.93,5a152.6,152.6,0,0,0-24.5,21.26A129.56,129.56,0,0,0,86,707.47a177.56,177.56,0,0,0,5.77,42.34h109a33.3,33.3,0,0,0,3.42-4.86,35.82,35.82,0,0,0,5.59-17.66A27.25,27.25,0,0,0,206,713.78c-2.88-4.86-7.75-10.27-16.22-15.86a8.8,8.8,0,0,1-3.78-7.21l.72-3.6h0a181.63,181.63,0,0,1,24-36.4c15.68-18.38,39.46-38.38,71.53-41.44h2l451.9,65.95h136V659.55a8.65,8.65,0,0,1,17.3,0v90.09h138.2a160.29,160.29,0,0,0-3.42-20.72c-3.78-16.4-11.71-35.5-25.95-47.57-9.55-7.93-21.8-13.33-39.46-13.33a8.65,8.65,0,0,1-8.65-8.65V602.79a8.65,8.65,0,0,1,17.3,0v49.37c17.12,1.62,31.35,7.57,42,16.76a84.39,84.39,0,0,1,7,6.85h4c.54-.18,1.62-.36,2.88-.72a106.2,106.2,0,0,0,10.63-3.78,118.68,118.68,0,0,0,32.79-21.08c19.28-17.48,38.92-45.95,45.77-93.51l32.07,25.23-.18.18,45,56.94,108.83-72.07A75.48,75.48,0,0,0,1276.47,539.55ZM1113.94,86.39a12.8,12.8,0,0,1,0,25.59h0a12.8,12.8,0,1,1-1.08-25.59Z",
  transform: "translate(-86 -19)"
});

var SvgDakelOnlyGradient = function SvgDakelOnlyGradient(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 1212.27 730.82",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDakelOnlyGradient, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Dakel_only_gradient.30c30373.svg";
export { ForwardRef as ReactComponent };